var tabContents;

function changeTab(selectedTab) {
  tabContents.hide();
  $(tabContents[selectedTab]).show();
}

function changeButtonActiveState(selectedTab) {
  $('.faq-container__menu-btn').removeClass('active');
  $($('.faq-container__menu-btn')[selectedTab]).addClass('active');
}

function initialiseQuestionsSwitch() {
  var initialTabSelected = 0;
  var returnsTabIndex = 5;

  tabContents = $('.category');

  if (window.location.hash === '#returns') {
    changeTab(returnsTabIndex);
    $($('.faq-container__menu-btn')[returnsTabIndex]).addClass('active');
  } else {
    changeTab(initialTabSelected);
    $('.faq-container__menu-btn:first').addClass('active')
  }

  $('.faq-container__menu-btn').on('click', function (event) {
    var data = $(event.target).data();

    selectedTab = data.index;
    changeTab(selectedTab);
    changeButtonActiveState(selectedTab);
  });

  $('.site-footer [href="/pages/f-a-q#returns"]').on('click', function () {
    changeTab(5);
    changeButtonActiveState(5);
  });
}

function main() {
  initialiseQuestionsSwitch();
}

$('document').ready(main);
